import React from "react";

const FieldDescription = ({ label, description, children, className = "" }) => (
  <div className={`tw-w-full tw-text-dis-small ${className}`}>
    <div className="tw-mb-2 tw-block tw-text-base tw-font-bold tw-text-dis-navy">
      {label}
    </div>
    {description && (
      <div
        role="paragraph"
        className="tw-text-dis-small tw-text-dis-text-muted"
      >
        {description}
      </div>
    )}
    {children}
  </div>
);

export default FieldDescription;
